export const CARD = "bg-[#0f1419] border-gray-800";
export const INPUT = "bg-[#1a1a1b] border-gray-700 text-white";
export const SELECT = "bg-[#1a1a1b] border border-gray-700 text-white rounded px-3 py-2";
export const PRIMARY_BTN = "bg-ism-teal hover:bg-ism-teal/90 text-white";
export const OUTLINE_BTN = "border-gray-700 text-gray-400";
